import React from 'react';

export const KeyholeIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path id="keyhole-square" d="M18.214,0H1.786A1.787,1.787,0,0,0,0,1.786V18.215A1.787,1.787,0,0,0,1.786,20H18.214A1.788,1.788,0,0,0,20,18.215V1.786A1.788,1.788,0,0,0,18.214,0ZM12.083,14.94a.417.417,0,0,1-.411.477H8.093a.417.417,0,0,1-.408-.495l1.046-4.883a2.858,2.858,0,0,1,.578-5.377,2.91,2.91,0,0,1,3.608,2.793,2.867,2.867,0,0,1-1.648,2.583Z" />
        </svg>
    )
}